// src/data/mockData.js

import {
  generateCustomers,
  generatePayments,
  enhancePickups,
  enhanceDeliveries,
  generateCompletedJobs,
} from './mockDataGenerators';



export const mockCustomers = generateCustomers(30);



export const mockOrders = [
  {
    id: 101,
    number: "ORD-00101",
    customerId: 1,
    customerName: "Alice Johnson",
    serviceType: "Wash & Fold",
    status: "Waiting",
    paymentStatus: "Pending",
    amount: 15.0,
    tax: 1.5,
    totalAmount: 16.5,
    date: "2026-06-05",
    pickupDate: "2026-06-05",
    deliveryDate: "2026-06-07",
    itemDetails: [{ name: "Dishdasha", quantity: 10, unitPrice: 1.5 }],
    notes: "",
    createdBy: "Counter Staff",
    branchId: 1,
    timeline: [
      { status: "Waiting", date: "06/05/2026", time: "01:00 AM", updatedBy: "Dana Lee" }
    ]
  },
  {
    id: 102,
    number: "ORD-00102",
    customerId: 2,
    customerName: "Bob Smith",
    serviceType: "Wash & Iron",
    status: "In Workshop",
    paymentStatus: "Paid",
    amount: 7.5,
    tax: 0.75,
    totalAmount: 8.25,
    date: "2026-06-05",
    pickupDate: "2026-06-05",
    deliveryDate: "2026-06-07",
    itemDetails: [{ name: "Shirt", quantity: 10, unitPrice: 0.75 }],
    notes: "",
    createdBy: "Counter Staff",
    branchId: 2,
    timeline: [
      { status: "Waiting", date: "06/05/2026", time: "01:00 AM", updatedBy: "Dana Lee" },
      { status: "In Workshop", date: "06/05/2026", time: "01:15 AM", updatedBy: "John Doe" }
    ]
  },
  {
    id: 103,
    number: "ORD-00103",
    customerId: 3,
    customerName: "Carol Davis",
    serviceType: "Dry Cleaning",
    status: "Ready",
    paymentStatus: "Partial",
    amount: 15.0,
    tax: 1.5,
    totalAmount: 16.5,
    date: "2026-06-05",
    pickupDate: "2026-06-05",
    deliveryDate: "2026-06-07",
    itemDetails: [{ name: "Jacket", quantity: 10, unitPrice: 1.5 }],
    notes: "",
    createdBy: "Counter Staff",
    branchId: 3,
    timeline: [
      { status: "Waiting", date: "06/05/2026", time: "01:00 AM", updatedBy: "Dana Lee" },
      { status: "In Workshop", date: "06/05/2026", time: "01:15 AM", updatedBy: "John Doe" },
      { status: "Ready", date: "06/05/2026", time: "03:00 AM", updatedBy: "Evan Wu" }
    ]
  },
  {
    id: 104,
    number: "ORD-00104",
    customerId: 4,
    customerName: "Diana Wilson",
    serviceType: "Blanket Cleaning",
    status: "In Shop",
    paymentStatus: "Pending",
    amount: 50.0,
    tax: 5.0,
    totalAmount: 55.0,
    date: "2026-06-04",
    pickupDate: "2026-06-04",
    deliveryDate: "2026-06-06",
    itemDetails: [{ name: "Carpet", quantity: 10, unitPrice: 5.0 }],
    notes: "",
    createdBy: "Counter Staff",
    branchId: 4,
    timeline: [
      { status: "Waiting", date: "06/04/2026", time: "09:00 AM", updatedBy: "Dana Lee" },
      { status: "In Workshop", date: "06/04/2026", time: "09:30 AM", updatedBy: "John Doe" },
      { status: "Ready", date: "06/04/2026", time: "11:00 AM", updatedBy: "Evan Wu" },
      { status: "In Shop", date: "06/04/2026", time: "11:15 AM", updatedBy: "Sarah Martinez" }
    ]
  },
  {
    id: 105,
    number: "ORD-00105",
    customerId: 5,
    customerName: "Eve Martinez",
    serviceType: "Premium Care",
    status: "H Services",
    paymentStatus: "Paid",
    amount: 150.0,
    tax: 15.0,
    totalAmount: 165.0,
    date: "2026-06-04",
    pickupDate: "2026-06-04",
    deliveryDate: "2026-06-11",
    itemDetails: [{ name: "Wedding Dress", quantity: 10, unitPrice: 15.0 }],
    notes: "",
    createdBy: "Counter Staff",
    branchId: 5,
    timeline: [
      { status: "Waiting", date: "06/04/2026", time: "10:00 AM", updatedBy: "Dana Lee" },
      { status: "In Workshop", date: "06/04/2026", time: "10:45 AM", updatedBy: "John Doe" },
      { status: "Ready", date: "06/04/2026", time: "02:00 PM", updatedBy: "Evan Wu" },
      { status: "In Shop", date: "06/04/2026", time: "02:30 PM", updatedBy: "Sarah Martinez" },
      { status: "H Services", date: "06/04/2026", time: "03:00 PM", updatedBy: "Dana Lee" }
    ]
  },
  {
    id: 106,
    number: "ORD-00106",
    customerId: 6,
    customerName: "Frank Turner",
    serviceType: "Ironing",
    status: "With Driver",
    paymentStatus: "Pending",
    amount: 7.5,
    tax: 0.75,
    totalAmount: 8.25,
    date: "2026-06-04",
    pickupDate: "2026-06-04",
    deliveryDate: "2026-06-05",
    itemDetails: [{ name: "Trousers", quantity: 10, unitPrice: 0.75 }],
    notes: "",
    createdBy: "Counter Staff",
    branchId: 6,
    timeline: [
      { status: "Waiting", date: "06/04/2026", time: "08:00 AM", updatedBy: "Dana Lee" },
      { status: "In Workshop", date: "06/04/2026", time: "08:30 AM", updatedBy: "John Doe" },
      { status: "Ready", date: "06/04/2026", time: "10:00 AM", updatedBy: "Evan Wu" },
      { status: "In Shop", date: "06/04/2026", time: "10:30 AM", updatedBy: "Sarah Martinez" },
      { status: "H Services", date: "06/04/2026", time: "11:00 AM", updatedBy: "Dana Lee" },
      { status: "With Driver", date: "06/04/2026", time: "11:30 AM", updatedBy: "Frank Brown" }
    ]
  },
  {
    id: 107,
    number: "ORD-00107",
    customerId: 7,
    customerName: "Grace Lee",
    serviceType: "Wash & Fold",
    status: "Delivered",
    paymentStatus: "Paid",
    amount: 20.0,
    tax: 2.0,
    totalAmount: 22.0,
    date: "2026-06-03",
    pickupDate: "2026-06-03",
    deliveryDate: "2026-06-05",
    itemDetails: [{ name: "Abaya", quantity: 10, unitPrice: 2.0 }],
    notes: "",
    createdBy: "Counter Staff",
    branchId: 7,
    timeline: [
      { status: "Waiting", date: "06/03/2026", time: "09:00 AM", updatedBy: "Dana Lee" },
      { status: "In Workshop", date: "06/03/2026", time: "09:30 AM", updatedBy: "John Doe" },
      { status: "Ready", date: "06/03/2026", time: "11:00 AM", updatedBy: "Evan Wu" },
      { status: "In Shop", date: "06/03/2026", time: "11:30 AM", updatedBy: "Sarah Martinez" },
      { status: "H Services", date: "06/03/2026", time: "12:00 PM", updatedBy: "Dana Lee" },
      { status: "With Driver", date: "06/03/2026", time: "01:30 PM", updatedBy: "Frank Brown" },
      { status: "Delivered", date: "06/03/2026", time: "03:00 PM", updatedBy: "Frank Brown" }
    ]
  },
  {
    id: 108,
    number: "ORD-00108",
    customerId: 1,
    customerName: "Alice Johnson",
    serviceType: "Dry Cleaning",
    status: "On Hold",
    paymentStatus: "Pending",
    amount: 20.0,
    tax: 2.0,
    totalAmount: 22.0,
    date: "2026-06-03",
    pickupDate: "2026-06-03",
    deliveryDate: "2026-06-05",
    itemDetails: [{ name: "Coat", quantity: 10, unitPrice: 2.0 }],
    notes: "",
    createdBy: "Counter Staff",
    branchId: 8,
    timeline: [
      { status: "Waiting", date: "06/03/2026", time: "10:00 AM", updatedBy: "Dana Lee" },
      { status: "In Workshop", date: "06/03/2026", time: "11:00 AM", updatedBy: "John Doe" },
      { status: "On Hold", date: "06/03/2026", time: "11:30 AM", updatedBy: "Dana Lee" }
    ]
  },
  {
    id: 109,
    number: "ORD-00109",
    customerId: 2,
    customerName: "Bob Smith",
    serviceType: "Wash & Fold",
    status: "Return",
    paymentStatus: "Pending",
    amount: 15.0,
    tax: 1.5,
    totalAmount: 16.5,
    date: "2026-06-02",
    pickupDate: "2026-06-02",
    deliveryDate: "2026-06-04",
    itemDetails: [{ name: "Sheet", quantity: 10, unitPrice: 1.5 }],
    notes: "",
    createdBy: "Counter Staff",
    branchId: 1,
    timeline: [
      { status: "Waiting", date: "06/02/2026", time: "09:00 AM", updatedBy: "Dana Lee" },
      { status: "In Workshop", date: "06/02/2026", time: "09:30 AM", updatedBy: "John Doe" },
      { status: "Ready", date: "06/02/2026", time: "11:00 AM", updatedBy: "Evan Wu" },
      { status: "In Shop", date: "06/02/2026", time: "11:30 AM", updatedBy: "Sarah Martinez" },
      { status: "Return", date: "06/02/2026", time: "01:00 PM", updatedBy: "Sarah Martinez" }
    ]
  },
  {
    id: 110,
    number: "ORD-00110",
    customerId: 3,
    customerName: "Carol Davis",
    serviceType: "Dry Cleaning",
    status: "Cancel",
    paymentStatus: "Pending",
    amount: 25.0,
    tax: 2.5,
    totalAmount: 27.5,
    date: "2026-06-02",
    pickupDate: "2026-06-02",
    deliveryDate: "2026-06-04",
    itemDetails: [{ name: "Suit", quantity: 10, unitPrice: 2.5 }],
    notes: "",
    createdBy: "Counter Staff",
    branchId: 2,
    timeline: [
      { status: "Waiting", date: "06/02/2026", time: "10:00 AM", updatedBy: "Dana Lee" },
      { status: "Cancel", date: "06/02/2026", time: "11:30 AM", updatedBy: "Dana Lee" }
    ]
  },
  {
    id: 111,
    number: "ORD-00111",
    customerId: 4,
    customerName: "Diana Wilson",
    serviceType: "Wash & Iron",
    status: "In Store",
    paymentStatus: "Paid",
    amount: 5.0,
    tax: 0.5,
    totalAmount: 5.5,
    date: "2026-06-02",
    pickupDate: "2026-06-02",
    deliveryDate: "2026-06-04",
    itemDetails: [{ name: "Ghotraa", quantity: 10, unitPrice: 0.5 }],
    notes: "",
    createdBy: "Counter Staff",
    branchId: 3,
    timeline: [
      { status: "Waiting", date: "06/02/2026", time: "02:00 PM", updatedBy: "Dana Lee" },
      { status: "In Store", date: "06/02/2026", time: "03:30 PM", updatedBy: "Sarah Martinez" }
    ]
  },
  // ── Express orders (one per branch) ──
  {
    id: 201,
    number: "ORD-00201",
    customerId: 1,
    customerName: "Alice Johnson",
    serviceType: "Urgent",
    status: "Waiting",
    paymentStatus: "Pending",
    amount: 22.5,
    tax: 2.25,
    totalAmount: 24.75,
    date: "2026-06-08",
    pickupDate: "2026-06-08",
    deliveryDate: "2026-06-08",
    itemDetails: [{ name: "Dishdasha", quantity: 3, unitPrice: 7.5 }],
    notes: "Express / Urgent",
    createdBy: "Counter Staff",
    staffName: "Dana Lee",
    branchId: 1,
    timeline: [
      { status: "Waiting", date: "06/08/2026", time: "08:00 AM", updatedBy: "Dana Lee" }
    ]
  },
  {
    id: 202,
    number: "ORD-00202",
    customerId: 2,
    customerName: "Bob Smith",
    serviceType: "Urgent",
    status: "In Workshop",
    paymentStatus: "Paid",
    amount: 15.0,
    tax: 1.5,
    totalAmount: 16.5,
    date: "2026-06-08",
    pickupDate: "2026-06-08",
    deliveryDate: "2026-06-08",
    itemDetails: [{ name: "Shirt", quantity: 5, unitPrice: 3.0 }],
    notes: "Express / Urgent",
    createdBy: "Counter Staff",
    staffName: "Evan Wu",
    branchId: 2,
    timeline: [
      { status: "Waiting", date: "06/08/2026", time: "08:15 AM", updatedBy: "Evan Wu" },
      { status: "In Workshop", date: "06/08/2026", time: "08:30 AM", updatedBy: "Evan Wu" }
    ]
  },
  {
    id: 203,
    number: "ORD-00203",
    customerId: 3,
    customerName: "Carol Davis",
    serviceType: "Urgent",
    status: "Ready",
    paymentStatus: "Paid",
    amount: 18.0,
    tax: 1.8,
    totalAmount: 19.8,
    date: "2026-06-08",
    pickupDate: "2026-06-08",
    deliveryDate: "2026-06-08",
    itemDetails: [{ name: "Jacket", quantity: 2, unitPrice: 9.0 }],
    notes: "Express / Urgent",
    createdBy: "Counter Staff",
    staffName: "Sarah Martinez",
    branchId: 3,
    timeline: [
      { status: "Waiting", date: "06/08/2026", time: "07:30 AM", updatedBy: "Sarah Martinez" },
      { status: "In Workshop", date: "06/08/2026", time: "07:45 AM", updatedBy: "Sarah Martinez" },
      { status: "Ready", date: "06/08/2026", time: "09:00 AM", updatedBy: "Evan Wu" }
    ]
  },
  {
    id: 204,
    number: "ORD-00204",
    customerId: 4,
    customerName: "Diana Wilson",
    serviceType: "Urgent",
    status: "Waiting",
    paymentStatus: "Pending",
    amount: 30.0,
    tax: 3.0,
    totalAmount: 33.0,
    date: "2026-06-08",
    pickupDate: "2026-06-08",
    deliveryDate: "2026-06-08",
    itemDetails: [{ name: "Carpet", quantity: 1, unitPrice: 30.0 }],
    notes: "Express / Urgent",
    createdBy: "Counter Staff",
    staffName: "Kevin Park",
    branchId: 4,
    timeline: [
      { status: "Waiting", date: "06/08/2026", time: "09:00 AM", updatedBy: "Kevin Park" }
    ]
  },
  {
    id: 205,
    number: "ORD-00205",
    customerId: 5,
    customerName: "Eve Martinez",
    serviceType: "Urgent",
    status: "In Workshop",
    paymentStatus: "Partial",
    amount: 12.0,
    tax: 1.2,
    totalAmount: 13.2,
    date: "2026-06-08",
    pickupDate: "2026-06-08",
    deliveryDate: "2026-06-08",
    itemDetails: [{ name: "Abaya", quantity: 2, unitPrice: 6.0 }],
    notes: "Express / Urgent",
    createdBy: "Counter Staff",
    staffName: "Lisa Thompson",
    branchId: 5,
    timeline: [
      { status: "Waiting", date: "06/08/2026", time: "08:45 AM", updatedBy: "Lisa Thompson" },
      { status: "In Workshop", date: "06/08/2026", time: "09:00 AM", updatedBy: "Lisa Thompson" }
    ]
  },
  {
    id: 206,
    number: "ORD-00206",
    customerId: 6,
    customerName: "Frank Turner",
    serviceType: "Urgent",
    status: "Ready",
    paymentStatus: "Paid",
    amount: 10.0,
    tax: 1.0,
    totalAmount: 11.0,
    date: "2026-06-08",
    pickupDate: "2026-06-08",
    deliveryDate: "2026-06-08",
    itemDetails: [{ name: "Trousers", quantity: 4, unitPrice: 2.5 }],
    notes: "Express / Urgent",
    createdBy: "Counter Staff",
    staffName: "Jennifer Lee",
    branchId: 6,
    timeline: [
      { status: "Waiting", date: "06/08/2026", time: "07:00 AM", updatedBy: "Jennifer Lee" },
      { status: "In Workshop", date: "06/08/2026", time: "07:15 AM", updatedBy: "Jennifer Lee" },
      { status: "Ready", date: "06/08/2026", time: "08:30 AM", updatedBy: "Evan Wu" }
    ]
  },
  {
    id: 207,
    number: "ORD-00207",
    customerId: 7,
    customerName: "Grace Lee",
    serviceType: "Urgent",
    status: "With Driver",
    paymentStatus: "Paid",
    amount: 20.0,
    tax: 2.0,
    totalAmount: 22.0,
    date: "2026-06-08",
    pickupDate: "2026-06-08",
    deliveryDate: "2026-06-08",
    itemDetails: [{ name: "Dress", quantity: 4, unitPrice: 5.0 }],
    notes: "Express / Urgent",
    createdBy: "Counter Staff",
    staffName: "Michael Torres",
    branchId: 7,
    timeline: [
      { status: "Waiting", date: "06/08/2026", time: "07:30 AM", updatedBy: "Michael Torres" },
      { status: "In Workshop", date: "06/08/2026", time: "07:45 AM", updatedBy: "Michael Torres" },
      { status: "Ready", date: "06/08/2026", time: "09:00 AM", updatedBy: "Evan Wu" },
      { status: "With Driver", date: "06/08/2026", time: "09:30 AM", updatedBy: "Frank Brown" }
    ]
  },
  {
    id: 208,
    number: "ORD-00208",
    customerId: 1,
    customerName: "Alice Johnson",
    serviceType: "Urgent",
    status: "Delivered",
    paymentStatus: "Paid",
    amount: 9.0,
    tax: 0.9,
    totalAmount: 9.9,
    date: "2026-06-08",
    pickupDate: "2026-06-08",
    deliveryDate: "2026-06-08",
    itemDetails: [{ name: "Shmage", quantity: 4, unitPrice: 2.25 }],
    notes: "Express / Urgent",
    createdBy: "Counter Staff",
    staffName: "Dana Lee",
    branchId: 8,
    timeline: [
      { status: "Waiting", date: "06/08/2026", time: "06:00 AM", updatedBy: "Dana Lee" },
      { status: "In Workshop", date: "06/08/2026", time: "06:15 AM", updatedBy: "Dana Lee" },
      { status: "Ready", date: "06/08/2026", time: "07:00 AM", updatedBy: "Evan Wu" },
      { status: "With Driver", date: "06/08/2026", time: "07:30 AM", updatedBy: "Frank Brown" },
      { status: "Delivered", date: "06/08/2026", time: "08:30 AM", updatedBy: "Frank Brown" }
    ]
  },
  // ── Additional normal orders for branches 4-8 (ensure every branch has at least 2 orders) ──
  {
    id: 212,
    number: "ORD-00212",
    customerId: 5,
    customerName: "Eve Martinez",
    serviceType: "Wash & Fold",
    status: "Waiting",
    paymentStatus: "Pending",
    amount: 12.0,
    tax: 1.2,
    totalAmount: 13.2,
    date: "2026-06-07",
    pickupDate: "2026-06-07",
    deliveryDate: "2026-06-09",
    itemDetails: [{ name: "Hegab", quantity: 8, unitPrice: 1.5 }],
    notes: "",
    createdBy: "Counter Staff",
    staffName: "Lisa Thompson",
    branchId: 4,
    timeline: [
      { status: "Waiting", date: "06/07/2026", time: "10:00 AM", updatedBy: "Lisa Thompson" }
    ]
  },
  {
    id: 213,
    number: "ORD-00213",
    customerId: 6,
    customerName: "Frank Turner",
    serviceType: "Wash & Iron",
    status: "In Workshop",
    paymentStatus: "Paid",
    amount: 7.5,
    tax: 0.75,
    totalAmount: 8.25,
    date: "2026-06-07",
    pickupDate: "2026-06-07",
    deliveryDate: "2026-06-09",
    itemDetails: [{ name: "Shirt", quantity: 10, unitPrice: 0.75 }],
    notes: "",
    createdBy: "Counter Staff",
    staffName: "Kevin Park",
    branchId: 5,
    timeline: [
      { status: "Waiting", date: "06/07/2026", time: "11:00 AM", updatedBy: "Kevin Park" },
      { status: "In Workshop", date: "06/07/2026", time: "11:30 AM", updatedBy: "Kevin Park" }
    ]
  },
  {
    id: 214,
    number: "ORD-00214",
    customerId: 7,
    customerName: "Grace Lee",
    serviceType: "Dry Cleaning",
    status: "Ready",
    paymentStatus: "Paid",
    amount: 15.0,
    tax: 1.5,
    totalAmount: 16.5,
    date: "2026-06-07",
    pickupDate: "2026-06-07",
    deliveryDate: "2026-06-09",
    itemDetails: [{ name: "Coat", quantity: 3, unitPrice: 5.0 }],
    notes: "",
    createdBy: "Counter Staff",
    staffName: "Jennifer Lee",
    branchId: 6,
    timeline: [
      { status: "Waiting", date: "06/07/2026", time: "09:00 AM", updatedBy: "Jennifer Lee" },
      { status: "In Workshop", date: "06/07/2026", time: "09:30 AM", updatedBy: "Jennifer Lee" },
      { status: "Ready", date: "06/07/2026", time: "12:00 PM", updatedBy: "Evan Wu" }
    ]
  },
  {
    id: 215,
    number: "ORD-00215",
    customerId: 2,
    customerName: "Bob Smith",
    serviceType: "Wash & Fold",
    status: "Waiting",
    paymentStatus: "Pending",
    amount: 10.0,
    tax: 1.0,
    totalAmount: 11.0,
    date: "2026-06-07",
    pickupDate: "2026-06-07",
    deliveryDate: "2026-06-09",
    itemDetails: [{ name: "Bisht", quantity: 2, unitPrice: 5.0 }],
    notes: "",
    createdBy: "Counter Staff",
    staffName: "Michael Torres",
    branchId: 7,
    timeline: [
      { status: "Waiting", date: "06/07/2026", time: "01:00 PM", updatedBy: "Michael Torres" }
    ]
  },
  {
    id: 216,
    number: "ORD-00216",
    customerId: 3,
    customerName: "Carol Davis",
    serviceType: "Premium Care",
    status: "In Workshop",
    paymentStatus: "Partial",
    amount: 25.0,
    tax: 2.5,
    totalAmount: 27.5,
    date: "2026-06-07",
    pickupDate: "2026-06-07",
    deliveryDate: "2026-06-10",
    itemDetails: [{ name: "Evening Dress", quantity: 2, unitPrice: 12.5 }],
    notes: "",
    createdBy: "Counter Staff",
    staffName: "Dana Lee",
    branchId: 8,
    timeline: [
      { status: "Waiting", date: "06/07/2026", time: "02:00 PM", updatedBy: "Dana Lee" },
      { status: "In Workshop", date: "06/07/2026", time: "02:30 PM", updatedBy: "Dana Lee" }
    ]
  }
];

export const mockServices = [
  { id: 1, name: "Wash & Fold", category: "Washing", price: 2.5, estimatedTime: "24 hours", status: "Active", description: "Standard wash and fold service" },
  { id: 2, name: "Dry Cleaning", category: "Dry Cleaning", price: 5.0, estimatedTime: "48 hours", status: "Active", description: "Professional dry cleaning" },
  { id: 3, name: "Ironing", category: "Ironing", price: 1.5, estimatedTime: "12 hours", status: "Active", description: "Professional ironing service" },
  { id: 4, name: "Wash & Iron", category: "Wash & Iron", price: 4.0, estimatedTime: "36 hours", status: "Active", description: "Wash and iron combined" },
  { id: 5, name: "Premium Care", category: "Premium Care", price: 8.0, estimatedTime: "72 hours", status: "Active", description: "Delicate fabric care" },
  { id: 6, name: "Stain Removal", category: "Premium Care", price: 3.5, estimatedTime: "48 hours", status: "Active", description: "Special stain treatment" },
  { id: 7, name: "Express Wash", category: "Washing", price: 4.5, estimatedTime: "6 hours", status: "Active", description: "Fast turnaround wash" },
  { id: 8, name: "Blanket Cleaning", category: "Washing", price: 6.0, estimatedTime: "48 hours", status: "Active", description: "Large item cleaning" },
  { id: 9, name: "Wool Care", category: "Premium Care", price: 7.0, estimatedTime: "72 hours", status: "Inactive", description: "Specialized wool cleaning" },
  { id: 10, name: "Silk Handling", category: "Premium Care", price: 9.0, estimatedTime: "72 hours", status: "Active", description: "Delicate silk treatment" },
  { id: 11, name: "Wedding Dress", category: "Premium Care", price: 25.0, estimatedTime: "7 days", status: "Active", description: "Special occasion dress care" },
  { id: 12, name: "Leather Cleaning", category: "Premium Care", price: 12.0, estimatedTime: "72 hours", status: "Active", description: "Leather item care" },
  { id: 13, name: "Uniform Cleaning", category: "Dry Cleaning", price: 3.0, estimatedTime: "24 hours", status: "Active", description: "Professional uniform cleaning" },
  { id: 14, name: "Suit Pressing", category: "Ironing", price: 2.5, estimatedTime: "12 hours", status: "Active", description: "Suit dry cleaning and pressing" },
  { id: 15, name: "Bulk Wash", category: "Washing", price: 1.5, estimatedTime: "24 hours", status: "Active", description: "Discounted bulk service" },
];

export const mockStaff = [
  // Admins — each assigned to a specific branch (branchId matches branches list)
  { id: 1, name: "Dana Lee", email: "dana@laundrymanagement.com", phone: "555-0001", address: "100 Executive Blvd", username: "danalee", role: "Admin", branch: "Ragheey", branchId: 1, status: "Active", joiningDate: "2024-01-15", ordersHandled: 0, deliveriesCompleted: 0, paymentsCollected: 0, recentActivity: "Approved new services" },
  { id: 2, name: "Marcus Johnson", email: "marcus@laundrymanagement.com", phone: "555-0002", address: "105 Corporate Ave", username: "marcusj", role: "Admin", branch: "Mishrif", branchId: 2, status: "Active", joiningDate: "2024-02-01", ordersHandled: 0, deliveriesCompleted: 0, paymentsCollected: 0, recentActivity: "Created new pickup route" },
  { id: 3, name: "Patricia Wong", email: "patricia@laundrymanagement.com", phone: "555-0003", address: "110 Business Ln", username: "patriciaw", role: "Admin", branch: "Andalus", branchId: 3, status: "Active", joiningDate: "2024-03-10", ordersHandled: 0, deliveriesCompleted: 0, paymentsCollected: 0, recentActivity: "Updated pricing" },

  // Counter Staff
  { id: 4, name: "Evan Wu", email: "evan@laundrymanagement.com", phone: "555-0004", address: "200 Main St", username: "evanwu", role: "Counter Staff", status: "Active", joiningDate: "2024-04-05", ordersHandled: 156, deliveriesCompleted: 0, paymentsCollected: 2340, recentActivity: "Processed order ORD-00102" },
  { id: 5, name: "Sarah Martinez", email: "sarah@laundrymanagement.com", phone: "555-0005", address: "205 Park Ave", username: "sarahm", role: "Counter Staff", status: "Active", joiningDate: "2024-04-10", ordersHandled: 142, deliveriesCompleted: 0, paymentsCollected: 2156, recentActivity: "Updated customer profile" },
  { id: 6, name: "Kevin Park", email: "kevin@laundrymanagement.com", phone: "555-0006", address: "210 Oak Street", username: "kevinp", role: "Counter Staff", status: "Active", joiningDate: "2024-05-01", ordersHandled: 128, deliveriesCompleted: 0, paymentsCollected: 1945, recentActivity: "Verified payment" },
  { id: 7, name: "Lisa Thompson", email: "lisa@laundrymanagement.com", phone: "555-0007", address: "215 Elm Rd", username: "lisat", role: "Counter Staff", status: "Active", joiningDate: "2024-05-15", ordersHandled: 134, deliveriesCompleted: 0, paymentsCollected: 2034, recentActivity: "Added new customer" },
  { id: 8, name: "David Chen", email: "david@laundrymanagement.com", phone: "555-0008", address: "220 Pine Ave", username: "davidc", role: "Counter Staff", status: "Inactive", joiningDate: "2024-06-01", ordersHandled: 89, deliveriesCompleted: 0, paymentsCollected: 1345, recentActivity: "On leave" },
  { id: 9, name: "Jennifer Lee", email: "jennifer@laundrymanagement.com", phone: "555-0009", address: "225 Maple Dr", username: "jenniferl", role: "Counter Staff", status: "Active", joiningDate: "2024-06-05", ordersHandled: 167, deliveriesCompleted: 0, paymentsCollected: 2523, recentActivity: "Handled customer complaint" },
  { id: 10, name: "Michael Torres", email: "michael@laundrymanagement.com", phone: "555-0010", address: "230 Cedar Ln", username: "michaelt", role: "Counter Staff", status: "Active", joiningDate: "2024-06-10", ordersHandled: 145, deliveriesCompleted: 0, paymentsCollected: 2189, recentActivity: "Processed refund" },
  { id: 11, name: "Amanda Rodriguez", email: "amanda@laundrymanagement.com", phone: "555-0011", address: "235 Birch St", username: "amandar", role: "Counter Staff", status: "Suspended", joiningDate: "2024-06-15", ordersHandled: 0, deliveriesCompleted: 0, paymentsCollected: 0, recentActivity: "Account suspended" },

  // Delivery Staff
  { id: 12, name: "Frank Brown", email: "frank@laundrymanagement.com", phone: "555-0012", address: "300 Industrial Ave", username: "frankb", role: "Delivery Staff", status: "Active", joiningDate: "2024-04-20", ordersHandled: 45, deliveriesCompleted: 89, paymentsCollected: 0, recentActivity: "Completed DEL-004" },
  { id: 13, name: "Henry Miller", email: "henry@laundrymanagement.com", phone: "555-0013", address: "305 Commerce Blvd", username: "henrym", role: "Delivery Staff", status: "Active", joiningDate: "2024-05-05", ordersHandled: 38, deliveriesCompleted: 76, paymentsCollected: 0, recentActivity: "Assigned to PKP-010" },
  { id: 14, name: "Robert Garcia", email: "robert@laundrymanagement.com", phone: "555-0014", address: "310 Factory Rd", username: "robertg", role: "Delivery Staff", status: "Active", joiningDate: "2024-05-20", ordersHandled: 52, deliveriesCompleted: 94, paymentsCollected: 0, recentActivity: "Started delivery route" },
  { id: 15, name: "Carlos Mendez", email: "carlos@laundrymanagement.com", phone: "555-0015", address: "315 Warehouse St", username: "carlasm", role: "Delivery Staff", status: "Active", joiningDate: "2024-06-01", ordersHandled: 41, deliveriesCompleted: 67, paymentsCollected: 0, recentActivity: "Updated pickup status" },
  { id: 16, name: "James Wilson", email: "james@laundrymanagement.com", phone: "555-0016", address: "320 Distribution Ln", username: "jamesw", role: "Delivery Staff", status: "Active", joiningDate: "2024-06-05", ordersHandled: 35, deliveriesCompleted: 58, paymentsCollected: 0, recentActivity: "Completed delivery route" },
  { id: 17, name: "Antonio Lopez", email: "antonio@laundrymanagement.com", phone: "555-0017", address: "325 Logistics Ave", username: "antoniol", role: "Delivery Staff", status: "Active", joiningDate: "2024-06-10", ordersHandled: 48, deliveriesCompleted: 82, paymentsCollected: 0, recentActivity: "Assigned to PKP-016" },
  { id: 18, name: "Diego Sanchez", email: "diego@laundrymanagement.com", phone: "555-0018", address: "330 Transport Dr", username: "diegos", role: "Delivery Staff", status: "Inactive", joiningDate: "2024-06-12", ordersHandled: 12, deliveriesCompleted: 18, paymentsCollected: 0, recentActivity: "Medical leave" },
  { id: 19, name: "Miguel Flores", email: "miguel@laundrymanagement.com", phone: "555-0019", address: "335 Route St", username: "miguelf", role: "Delivery Staff", status: "Active", joiningDate: "2024-06-15", ordersHandled: 33, deliveriesCompleted: 54, paymentsCollected: 0, recentActivity: "In transit with order" },
  { id: 20, name: "Victor Ramirez", email: "victor@laundrymanagement.com", phone: "555-0020", address: "340 Shipping Ln", username: "victorm", role: "Delivery Staff", status: "Active", joiningDate: "2024-06-18", ordersHandled: 29, deliveriesCompleted: 42, paymentsCollected: 0, recentActivity: "Ready for assignment" },
  { id: 21, name: "Eduardo Gutierrez", email: "eduardo@laundrymanagement.com", phone: "555-0021", address: "345 Cargo Ave", username: "eduardog", role: "Delivery Staff", status: "Active", joiningDate: "2024-06-20", ordersHandled: 44, deliveriesCompleted: 71, paymentsCollected: 0, recentActivity: "Completed DEL-020" },
];

export const mockRoles = [
  {
    id: 1,
    name: "Admin",
    description: "Full system access and administrative privileges",
    permissions: [
      "view_dashboard",
      "manage_customers",
      "manage_orders",
      "manage_services",
      "manage_pricing",
      "manage_pickups",
      "manage_deliveries",
      "manage_payments",
      "manage_staff",
      "manage_roles",
      "view_reports",
      "manage_notifications",
      "manage_settings",
      "view_analytics",
      "export_data",
      "manage_permissions",
    ],
  },
  {
    id: 2,
    name: "Counter Staff",
    description: "Counter and customer service operations",
    permissions: [
      "view_dashboard",
      "manage_customers",
      "create_orders",
      "view_orders",
      "manage_payments",
      "track_orders",
      "view_pickups",
      "view_deliveries",
    ],
  },
  {
    id: 3,
    name: "Delivery Staff",
    description: "Pickup and delivery operations",
    permissions: [
      "view_dashboard",
      "view_assigned_pickups",
      "update_pickup_status",
      "view_assigned_deliveries",
      "update_delivery_status",
      "view_completed_jobs",
      "view_route_map",
    ],
  },
];

export const permissionsReference = {
  view_dashboard: "View Dashboard",
  manage_customers: "Manage Customers",
  manage_orders: "Manage Orders",
  manage_services: "Manage Laundry Services",
  manage_pricing: "Manage Pricing",
  manage_pickups: "Manage Pickups",
  manage_deliveries: "Manage Deliveries",
  manage_payments: "Manage Payments",
  manage_staff: "Manage Staff",
  manage_roles: "Manage Roles",
  view_reports: "View Reports",
  manage_notifications: "Manage Notifications",
  manage_settings: "Manage Settings",
  view_analytics: "View Analytics",
  export_data: "Export Data",
  manage_permissions: "Manage Permissions",
  create_orders: "Create Orders",
  view_orders: "View Orders",
  track_orders: "Track Orders",
  view_pickups: "View Pickups",
  view_deliveries: "View Deliveries",
  view_assigned_pickups: "View Assigned Pickups",
  update_pickup_status: "Update Pickup Status",
  view_assigned_deliveries: "View Assigned Deliveries",
  update_delivery_status: "Update Delivery Status",
  view_completed_jobs: "View Completed Jobs",
  view_route_map: "View Route Map",
};

export const mockPayments = generatePayments(30, mockOrders);

const _rawPickups = [
  { id: 1, requestId: "PKP-001", customer: "Alice Johnson", address: "123 Main St", pickupDate: "2026-06-03", assignedStaff: "Frank Brown", status: "Scheduled", notes: "Call before pickup" },
  { id: 2, requestId: "PKP-002", customer: "Bob Smith", address: "456 Oak Ave", pickupDate: "2026-06-03", assignedStaff: "Henry Miller", status: "Assigned", notes: "" },
  { id: 3, requestId: "PKP-003", customer: "Carol Davis", address: "789 Pine Rd", pickupDate: "2026-06-04", assignedStaff: "", status: "Scheduled", notes: "" },
  { id: 4, requestId: "PKP-004", customer: "Diana Wilson", address: "321 Elm St", pickupDate: "2026-06-03", assignedStaff: "Frank Brown", status: "Picked Up", notes: "" },
  { id: 5, requestId: "PKP-005", customer: "Eve Martinez", address: "654 Maple Ave", pickupDate: "2026-06-05", assignedStaff: "", status: "Scheduled", notes: "Leave at porch" },
  { id: 6, requestId: "PKP-006", customer: "Alice Johnson", address: "123 Main St", pickupDate: "2026-06-04", assignedStaff: "Henry Miller", status: "Scheduled", notes: "" },
  { id: 7, requestId: "PKP-007", customer: "Bob Smith", address: "456 Oak Ave", pickupDate: "2026-06-05", assignedStaff: "", status: "Scheduled", notes: "Business hours only" },
  { id: 8, requestId: "PKP-008", customer: "Carol Davis", address: "789 Pine Rd", pickupDate: "2026-06-03", assignedStaff: "Frank Brown", status: "Completed", notes: "" },
  { id: 9, requestId: "PKP-009", customer: "Diana Wilson", address: "321 Elm St", pickupDate: "2026-06-06", assignedStaff: "", status: "Scheduled", notes: "" },
  { id: 10, requestId: "PKP-010", customer: "Eve Martinez", address: "654 Maple Ave", pickupDate: "2026-06-04", assignedStaff: "Henry Miller", status: "Assigned", notes: "" },
  { id: 11, requestId: "PKP-011", customer: "Alice Johnson", address: "123 Main St", pickupDate: "2026-06-05", assignedStaff: "", status: "Scheduled", notes: "" },
  { id: 12, requestId: "PKP-012", customer: "Bob Smith", address: "456 Oak Ave", pickupDate: "2026-06-06", assignedStaff: "Frank Brown", status: "Scheduled", notes: "" },
  { id: 13, requestId: "PKP-013", customer: "Carol Davis", address: "789 Pine Rd", pickupDate: "2026-06-05", assignedStaff: "", status: "Scheduled", notes: "" },
  { id: 14, requestId: "PKP-014", customer: "Diana Wilson", address: "321 Elm St", pickupDate: "2026-06-07", assignedStaff: "Henry Miller", status: "Assigned", notes: "" },
  { id: 15, requestId: "PKP-015", customer: "Eve Martinez", address: "654 Maple Ave", pickupDate: "2026-06-06", assignedStaff: "", status: "Scheduled", notes: "" },
  { id: 16, requestId: "PKP-016", customer: "Alice Johnson", address: "123 Main St", pickupDate: "2026-06-07", assignedStaff: "Frank Brown", status: "Scheduled", notes: "" },
  { id: 17, requestId: "PKP-017", customer: "Bob Smith", address: "456 Oak Ave", pickupDate: "2026-06-08", assignedStaff: "", status: "Scheduled", notes: "" },
  { id: 18, requestId: "PKP-018", customer: "Carol Davis", address: "789 Pine Rd", pickupDate: "2026-06-07", assignedStaff: "Henry Miller", status: "Assigned", notes: "" },
  { id: 19, requestId: "PKP-019", customer: "Diana Wilson", address: "321 Elm St", pickupDate: "2026-06-08", assignedStaff: "", status: "Scheduled", notes: "" },
  { id: 20, requestId: "PKP-020", customer: "Eve Martinez", address: "654 Maple Ave", pickupDate: "2026-06-07", assignedStaff: "Frank Brown", status: "Picked Up", notes: "" },
];

export const mockPickups = enhancePickups(_rawPickups, mockCustomers);

const _rawDeliveries = [
  { id: 1, deliveryId: "DEL-001", customer: "Alice Johnson", deliveryDate: "2026-06-05", assignedStaff: "Frank Brown", orderCount: 2, status: "Scheduled", address: "123 Main St" },
  { id: 2, deliveryId: "DEL-002", customer: "Bob Smith", deliveryDate: "2026-06-05", assignedStaff: "Henry Miller", orderCount: 1, status: "Out for Delivery", address: "456 Oak Ave" },
  { id: 3, deliveryId: "DEL-003", customer: "Carol Davis", deliveryDate: "2026-06-06", assignedStaff: "", orderCount: 1, status: "Scheduled", address: "789 Pine Rd" },
  { id: 4, deliveryId: "DEL-004", customer: "Diana Wilson", deliveryDate: "2026-06-05", assignedStaff: "Frank Brown", orderCount: 3, status: "Delivered", address: "321 Elm St" },
  { id: 5, deliveryId: "DEL-005", customer: "Eve Martinez", deliveryDate: "2026-06-07", assignedStaff: "", orderCount: 1, status: "Scheduled", address: "654 Maple Ave" },
  { id: 6, deliveryId: "DEL-006", customer: "Alice Johnson", deliveryDate: "2026-06-06", assignedStaff: "Henry Miller", orderCount: 2, status: "Scheduled", address: "123 Main St" },
  { id: 7, deliveryId: "DEL-007", customer: "Bob Smith", deliveryDate: "2026-06-07", assignedStaff: "", orderCount: 1, status: "Scheduled", address: "456 Oak Ave" },
  { id: 8, deliveryId: "DEL-008", customer: "Carol Davis", deliveryDate: "2026-06-05", assignedStaff: "Frank Brown", orderCount: 2, status: "Delivered", address: "789 Pine Rd" },
  { id: 9, deliveryId: "DEL-009", customer: "Diana Wilson", deliveryDate: "2026-06-08", assignedStaff: "", orderCount: 1, status: "Scheduled", address: "321 Elm St" },
  { id: 10, deliveryId: "DEL-010", customer: "Eve Martinez", deliveryDate: "2026-06-06", assignedStaff: "Henry Miller", orderCount: 2, status: "Out for Delivery", address: "654 Maple Ave" },
  { id: 11, deliveryId: "DEL-011", customer: "Alice Johnson", deliveryDate: "2026-06-07", assignedStaff: "", orderCount: 1, status: "Scheduled", address: "123 Main St" },
  { id: 12, deliveryId: "DEL-012", customer: "Bob Smith", deliveryDate: "2026-06-08", assignedStaff: "Frank Brown", orderCount: 2, status: "Scheduled", address: "456 Oak Ave" },
  { id: 13, deliveryId: "DEL-013", customer: "Carol Davis", deliveryDate: "2026-06-07", assignedStaff: "", orderCount: 1, status: "Scheduled", address: "789 Pine Rd" },
  { id: 14, deliveryId: "DEL-014", customer: "Diana Wilson", deliveryDate: "2026-06-09", assignedStaff: "Henry Miller", orderCount: 2, status: "Failed", address: "321 Elm St" },
  { id: 15, deliveryId: "DEL-015", customer: "Eve Martinez", deliveryDate: "2026-06-08", assignedStaff: "", orderCount: 1, status: "Scheduled", address: "654 Maple Ave" },
  { id: 16, deliveryId: "DEL-016", customer: "Alice Johnson", deliveryDate: "2026-06-09", assignedStaff: "Frank Brown", orderCount: 2, status: "Scheduled", address: "123 Main St" },
  { id: 17, deliveryId: "DEL-017", customer: "Bob Smith", deliveryDate: "2026-06-10", assignedStaff: "", orderCount: 1, status: "Scheduled", address: "456 Oak Ave" },
  { id: 18, deliveryId: "DEL-018", customer: "Carol Davis", deliveryDate: "2026-06-09", assignedStaff: "Henry Miller", orderCount: 2, status: "Out for Delivery", address: "789 Pine Rd" },
  { id: 19, deliveryId: "DEL-019", customer: "Diana Wilson", deliveryDate: "2026-06-10", assignedStaff: "", orderCount: 1, status: "Scheduled", address: "321 Elm St" },
  { id: 20, deliveryId: "DEL-020", customer: "Eve Martinez", deliveryDate: "2026-06-09", assignedStaff: "Frank Brown", orderCount: 2, status: "Delivered", address: "654 Maple Ave" },
];

export const mockDeliveries = enhanceDeliveries(_rawDeliveries, mockCustomers, mockOrders);

export const mockCompletedJobs = generateCompletedJobs(mockPickups, mockDeliveries);

// ── Branches ──────────────────────────────────────────────────────────────────
export const mockBranches = [
  { id: 1, name: 'Ragheey',  address: 'Block 3, Ragheey, Kuwait City', phone: '+965 2200 1001', email: 'ragheey@laundrymanagement.com',  status: 'Active', manager: 'Dana Lee',       isSystemBranch: false },
  { id: 2, name: 'Mishrif',  address: 'Block 5, Mishrif, Kuwait City', phone: '+965 2200 1002', email: 'mishrif@laundrymanagement.com',  status: 'Active', manager: 'Marcus Johnson', isSystemBranch: false },
  { id: 3, name: 'Andalus',  address: 'Block 2, Andalus, Kuwait',      phone: '+965 2200 1003', email: 'andalus@laundrymanagement.com',  status: 'Active', manager: 'Patricia Wong',  isSystemBranch: false },
  { id: 4, name: 'Ardiya',   address: 'Block 1, Ardiya, Kuwait',       phone: '+965 2200 1004', email: 'ardiya@laundrymanagement.com',   status: 'Active', manager: 'Evan Wu',        isSystemBranch: false },
  { id: 5, name: 'Khaitan',  address: 'Block 7, Khaitan, Kuwait',      phone: '+965 2200 1005', email: 'khaitan@laundrymanagement.com',  status: 'Active', manager: 'Sarah Martinez', isSystemBranch: false },
  { id: 6, name: 'Qurain',   address: 'Block 4, Qurain, Kuwait',       phone: '+965 2200 1006', email: 'qurain@laundrymanagement.com',   status: 'Active', manager: 'Kevin Park',     isSystemBranch: false },
  { id: 7, name: 'Jahra',    address: 'Main St, Jahra, Kuwait',        phone: '+965 2200 1007', email: 'jahra@laundrymanagement.com',    status: 'Active', manager: 'Lisa Thompson',  isSystemBranch: false },
  { id: 8, name: 'Rigai',    address: 'Block 9, Rigai, Kuwait',        phone: '+965 2200 1008', email: 'rigai@laundrymanagement.com',    status: 'Active', manager: 'David Chen',     isSystemBranch: false },
  { id: 9, name: 'Home Service', address: 'Central Logistics & Home Delivery Hub', phone: '+965 2222 0000', email: 'homeservice@laundrymanagement.com', status: 'Active', manager: '', isSystemBranch: true },
];

// ── Drivers ───────────────────────────────────────────────────────────────────
export const mockDrivers = [
  { id: 1, driverName: 'Frank Brown',      phone: '555-0012', vehicleType: 'Van',      licenseNumber: 'KW-1001', status: 'Available', branchId: 1, totalDeliveries: 89,  rating: 4.8 },
  { id: 2, driverName: 'Henry Miller',     phone: '555-0013', vehicleType: 'Motorbike', licenseNumber: 'KW-1002', status: 'Assigned',  branchId: 2, totalDeliveries: 76,  rating: 4.5 },
  { id: 3, driverName: 'Robert Garcia',    phone: '555-0014', vehicleType: 'Van',      licenseNumber: 'KW-1003', status: 'Available', branchId: 3, totalDeliveries: 94,  rating: 4.9 },
  { id: 4, driverName: 'Carlos Mendez',    phone: '555-0015', vehicleType: 'Car',      licenseNumber: 'KW-1004', status: 'Available', branchId: 4, totalDeliveries: 67,  rating: 4.3 },
  { id: 5, driverName: 'James Wilson',     phone: '555-0016', vehicleType: 'Van',      licenseNumber: 'KW-1005', status: 'Off Duty',  branchId: 5, totalDeliveries: 58,  rating: 4.6 },
  { id: 6, driverName: 'Antonio Lopez',    phone: '555-0017', vehicleType: 'Motorbike', licenseNumber: 'KW-1006', status: 'Assigned',  branchId: 6, totalDeliveries: 82,  rating: 4.4 },
  { id: 7, driverName: 'Diego Sanchez',    phone: '555-0018', vehicleType: 'Car',      licenseNumber: 'KW-1007', status: 'Off Duty',  branchId: 7, totalDeliveries: 18,  rating: 4.0 },
  { id: 8, driverName: 'Miguel Flores',    phone: '555-0019', vehicleType: 'Van',      licenseNumber: 'KW-1008', status: 'Available', branchId: 8, totalDeliveries: 54,  rating: 4.7 },
];

// ── Expenses ──────────────────────────────────────────────────────────────────
export const mockExpenses = [
  { id: 1, category: 'Utilities',    description: 'Electricity bill – Ragheey',  amount: 120.0, date: '2026-06-01', branchId: 1, createdBy: 'Dana Lee'       },
  { id: 2, category: 'Supplies',     description: 'Detergent bulk order',         amount: 85.5,  date: '2026-06-02', branchId: 2, createdBy: 'Marcus Johnson' },
  { id: 3, category: 'Maintenance',  description: 'Washing machine repair',       amount: 200.0, date: '2026-06-03', branchId: 3, createdBy: 'Patricia Wong'  },
  { id: 4, category: 'Staff',        description: 'Overtime pay – June week 1',   amount: 150.0, date: '2026-06-04', branchId: 1, createdBy: 'Dana Lee'       },
  { id: 5, category: 'Utilities',    description: 'Water bill – Andalus',         amount: 95.0,  date: '2026-06-05', branchId: 3, createdBy: 'Patricia Wong'  },
  { id: 6, category: 'Supplies',     description: 'Hangers and packaging',        amount: 40.0,  date: '2026-06-06', branchId: 4, createdBy: 'Evan Wu'        },
  { id: 7, category: 'Transport',    description: 'Fuel allowance – June',        amount: 75.0,  date: '2026-06-07', branchId: 2, createdBy: 'Marcus Johnson' },
  { id: 8, category: 'Maintenance',  description: 'AC servicing – Khaitan',      amount: 180.0, date: '2026-06-08', branchId: 5, createdBy: 'Sarah Martinez' },
];

// ── Areas (delivery zones) ────────────────────────────────────────────────────
export const mockAreas = [
  'Ragheey', 'Mishrif', 'Andalus', 'Ardiya', 'Khaitan',
  'Qurain', 'Jahra', 'Rigai', 'Rumaithiya', 'Bayan',
  'Salwa', 'Fintas', 'Mangaf', 'Fahaheel', 'Abu Halifa',
];

// ── Notifications / Audit log entries ────────────────────────────────────────
export const mockNotifications = [
  { id: 'n1', type: 'order',    title: 'New Invoice Created',       text: 'ORD-00201 created for Alice Johnson – Urgent service',      time: '2026-06-08T08:05:00Z', read: false, branchId: 1 },
  { id: 'n2', type: 'order',    title: 'Order Status Updated',      text: 'ORD-00102 moved to In Workshop by Evan Wu',                 time: '2026-06-08T08:30:00Z', read: false, branchId: 2 },
  { id: 'n3', type: 'payment',  title: 'Payment Received',          text: 'KWD 16.50 collected for ORD-00102 – Cash',                 time: '2026-06-08T09:00:00Z', read: true,  branchId: 2 },
  { id: 'n4', type: 'delivery', title: 'Delivery Assigned',         text: 'DEL-002 assigned to Henry Miller – Bob Smith',             time: '2026-06-08T09:15:00Z', read: false, branchId: 2 },
  { id: 'n5', type: 'order',    title: 'Order Ready for Pickup',    text: 'ORD-00203 is ready – Carol Davis',                         time: '2026-06-08T09:30:00Z', read: true,  branchId: 3 },
  { id: 'n6', type: 'system',   title: 'Branch Settings Updated',   text: 'Andalus branch contact info updated by Patricia Wong',      time: '2026-06-08T10:00:00Z', read: true,  branchId: null },
  { id: 'n7', type: 'delivery', title: 'Delivery Completed',        text: 'DEL-004 delivered to Diana Wilson by Frank Brown',         time: '2026-06-08T10:30:00Z', read: false, branchId: 1 },
  { id: 'n8', type: 'payment',  title: 'Balance Settled',           text: 'Customer Alice Johnson balance cleared – KWD 24.75',       time: '2026-06-08T11:00:00Z', read: false, branchId: 1 },
  { id: 'n9', type: 'order',    title: 'Order On Hold',             text: 'ORD-00108 placed on hold – fabric issue',                  time: '2026-06-07T14:00:00Z', read: true,  branchId: 8 },
  { id:'n10', type: 'system',   title: 'New Staff Added',           text: 'Kevin Park added as Counter Staff at Qurain branch',       time: '2026-06-07T12:00:00Z', read: true,  branchId: null },
];

// ── Mock users (for local authentication) ────────────────────────────────────
export const mockUsers = [
  { id: 'u1', name: 'Super Admin',   email: 'superadmin@laundrymanagement.com', password: 'admin123', role: 'Super Admin',    branchId: 'All', branch: 'All'       },
  { id: 'u2', name: 'Dana Lee',      email: 'dana@laundrymanagement.com',       password: 'admin123', role: 'Admin',          branchId: 1,     branch: 'Ragheey'   },
  { id: 'u3', name: 'Patricia Wong', email: 'patricia@laundrymanagement.com',   password: 'admin123', role: 'Admin',          branchId: 3,     branch: 'Andalus'   },
  { id: 'u4', name: 'Kevin Park',    email: 'kevin@laundrymanagement.com',      password: 'staff123', role: 'Counter Staff',  branchId: 2,     branch: 'Mishrif'   },
  { id: 'u5', name: 'Robert Garcia', email: 'robert@laundrymanagement.com',     password: 'rider123', role: 'Delivery Staff', branchId: 2,     branch: 'Mishrif'   },
  { id: 'u6', name: 'Marcus Johnson',email: 'marcus@laundrymanagement.com',     password: 'admin123', role: 'Admin',          branchId: 2,     branch: 'Mishrif'   },
  { id: 'u7', name: 'Evan Wu',       email: 'evan@laundrymanagement.com',       password: 'staff123', role: 'Counter Staff',  branchId: 1,     branch: 'Ragheey'   },
  { id: 'u8', name: 'Frank Brown',   email: 'frank@laundrymanagement.com',      password: 'rider123', role: 'Delivery Staff', branchId: 1,     branch: 'Ragheey'   },
];
